import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { isEqual } from 'lodash-es';
import { ConfirmationModal } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { useUpdateDraft } from './hooks/useUpdateDraft';
export default function DraftUpdateModal(props) {
    const { changeDraftInRow, renderContent, dismissModal, width, maxHeight, skin = 'primary', shouldSubmit = ()=>Promise.resolve(true), submitOnNotDirty = false } = props;
    const [draft, setDraft] = useState(props.draft);
    const { t: commonTexts } = useLocaleKeys('common');
    const { loading, updateDraft } = useUpdateDraft();
    const [wasSubmitted, setWasSubmitted] = useState(false);
    const isDirty = useMemo(()=>!isEqual(draft, props.draft), [
        draft,
        props.draft
    ]);
    const { title, testId, content, onSubmit, primaryButtonLabel = 'Save' } = renderContent({
        wasSubmitted,
        draft,
        setDraft
    });
    async function submit() {
        setWasSubmitted(true);
        if (!await shouldSubmit(draft)) return;
        updateDraft({
            newDraft: draft,
            onSuccess: ()=>{
                changeDraftInRow(draft);
                dismissModal();
            }
        });
    }
    const onPrimaryButtonClick = ()=>{
        if (isDirty || submitOnNotDirty) {
            onSubmit(submit);
        } else {
            dismissModal();
        }
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: title,
        testId: testId,
        content: content,
        width: width,
        maxHeight: maxHeight,
        skin: skin,
        primaryButtonLabel: primaryButtonLabel,
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        onCloseButtonClick: dismissModal,
        onSecondaryButtonClick: dismissModal,
        onPrimaryButtonClick: onPrimaryButtonClick,
        primaryButtonLoading: loading,
        primaryButtonTestId: "".concat(testId, "-confirm"),
        textAlignCenter: false
    });
}
